export type SeekMatchScoreState = 'computed' | 'missing' | 'stale' | 'failed' | 'calculating';

export interface SeekMatchScoreInput {
  score: number | null | undefined;
  computedAt?: string | null;
  profileUpdatedAt?: string | null;
  isCalculating?: boolean;
  isFailed?: boolean;
}

export interface SeekMatchScoreDisplay {
  state: SeekMatchScoreState;
  score: number | null;
}

function isValidScore(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 100;
}

function isStale(computedAt?: string | null, profileUpdatedAt?: string | null) {
  if (!computedAt || !profileUpdatedAt) return false;
  const computedTime = new Date(computedAt).getTime();
  const profileTime = new Date(profileUpdatedAt).getTime();
  return Number.isFinite(computedTime) && Number.isFinite(profileTime) && profileTime > computedTime;
}

export function resolveSeekMatchScoreState(input: SeekMatchScoreInput): SeekMatchScoreDisplay {
  if (input.isCalculating) return { state: 'calculating', score: null };
  if (input.isFailed) return { state: 'failed', score: null };
  if (!isValidScore(input.score)) return { state: 'missing', score: null };
  if (isStale(input.computedAt, input.profileUpdatedAt)) return { state: 'stale', score: null };
  return { state: 'computed', score: input.score };
}

export function hasComputedSeekMatchScore(display: SeekMatchScoreDisplay): display is SeekMatchScoreDisplay & { state: 'computed'; score: number } {
  return display.state === 'computed' && isValidScore(display.score);
}

export function seekMatchScoreSortValue(display: SeekMatchScoreDisplay): number {
  return hasComputedSeekMatchScore(display) ? display.score : -1;
}
